import React from 'react';
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

const AdminSkeleton = () => {
  return (
    <section className="desh-main-display" style={{width:"100%", overflowX: "hidden", height: "100%"}}>
              <Skeleton variant="rectangular"  height={650} sx={{ bgcolor: 'white' }}/>
              <h1 className="admin-loading-skeleton-h1">Data is loading...</h1>
          </section>
  )
}

export default AdminSkeleton;